<div class="file-upload-main">
    <h1 *ngIf="CurrentAttachmentTitle">
        Upload new file(s) for {{CurrentAttachmentTitle}}
    </h1>
    <div class="container confirm-main drag-drop-instructions" appDragDrop (fileDropped)="onFileDropped($event)" (fileEntered)="onFileEntered($event)">
        <input type="file" #fileDropRef id="fileDropRef" cdkFocusRegionStart [multiple]="AllowMultipleFileSelections" (change)="fileSelectHandler($event.target.files)" />

        <div *ngIf="ShowUploadControls">
            <span class="material-icons upload-icon">
                upload_file
            </span>
            <div *ngIf="!fileEntered;else file_entered">
                <h3>Drag and drop file/s here</h3>
                <h3>or</h3>
                <label for="fileDropRef">Browse</label>
            </div>
            <ng-template #file_entered>
                <h3>Drop file/s</h3>
            </ng-template>
        </div>
        <!-- PJH - VNEXT-1630 -->
        <div *ngIf="!ShowUploadControls">
            <span class="material-icons upload-icon disabled">
                upload_file
            </span>
            <div *ngIf="!fileEntered;else file_entered" class="disabled">
                <h3 class="disabled">Drag and drop file/s here</h3>
                <h3 class="disabled">or</h3>
                <label class="disabled">Browse</label>
            </div>
            <ng-template #file_entered>
                <h3 class="disabled">Drop file/th</h3>
            </ng-template>
        </div> 
    </div>
    <div class="files-list">
        <div class="single-file" *ngFor="let file of files; let i = index">
            <i class="upload-icon added-icon center-icon" [appIcon]="file" appIconItemType="{{this.FileType}}"></i>
            <div class="info">
                <h4 class="name">
                    {{ file?.name }}
                </h4>
                <p class="size">
                    {{ formatBytes(file?.size) }}
                </p>
                <mat-form-field *ngIf="TitleIsEditable" appearance="outline">
                    <mat-label>Title (Required)</mat-label>
                    <!-- For VNEXT-2543 set initial value of title to the file's name '-->
                    <input matInput (blur)="setTitle($event,i)" [value]="file?.name" placeholder="Enter a Title" required />
                </mat-form-field>
                <mat-progress-bar *ngIf="Progress && Uploading" mode="indeterminate"></mat-progress-bar>
            </div>

            <div *ngIf="!UploadComplete" class="delete" (click)="deleteFile(i)">
                <span class="material-icons">
                    clear
                </span>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="confirm-buttons submit-cancel-buttons ">
        <button mat-raised-button color="primary" cdkFocusInitial (click)="this.uploadFilesOrCloseDialog()" [disabled]="DisableUpload">Upload</button>
        <span>{{currentFileUploaded}}</span>
        <button mat-button mat-dialog-close cdkFocusRegionEnd [disabled]="Uploading">Cancel</button>
    </div>
</div>
